import { Component } from 'react';
import Loading from '../../../components/Loading';
import AiTrackingPrompt from '../prompt';
import { getProject } from './query';
import Message from '../../Message';
import MessageCustom from '../../../components/MessageCustom';
import { withTranslation } from 'react-i18next';

class AiTrackingProject extends Component {
    constructor() {
        super();

        this.getProjectData = this.getProjectData.bind(this);

        this.state = {
            loading: true,
            prompt_uids: [],
            platforms: [],
            message: '',
            project: null,
            notFound: false,
            loadingProjectForChildren: false,
        };
    }

    async getProjectData() {
        try {
            this.setState({ loadingProjectForChildren: true });
            const res = await getProject(this.props.id);
            const data = await res.json().catch(() => null);
            if (res.status === 200) {
                this.setState({
                    loading: false,
                    prompt_uids: data.prompts?.map((item) => item.prompt_uid),
                    platforms: [...new Set(data.prompts?.map((item) => item.platforms).flat())],
                    project: data,
                });
            } else if (res.status === 404) {
                // The API scopes projects to the current user, so a missing project and
                // someone else's project both come back as 404.
                this.setState({ notFound: true, loading: false });
            } else {
                this.setState({
                    message: data?.detail ?? this.props.t('global.something_went_wrong'),
                    message_tags: 'error',
                    loading: false,
                });
            }
        } catch (err) {
            this.setState({
                message: err?.message ?? this.props.t('global.something_went_wrong'),
                message_tags: 'error',
                loading: false,
            });
        } finally {
            this.setState({ loadingProjectForChildren: false });
        }
    }
    componentDidMount() {
        this.getProjectData();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                {this.state.loading && <Loading padding={10} />}
                {!this.state.loading && this.state.notFound && (
                    <div className="my-10">
                        <MessageCustom
                            message={t('ai_tracking.keyword_detail.messages.project_not_found')}
                            message_type={'alert-warning'}
                            link="/ai-tracking/"
                            link_name={t('ai_tracking.keyword_detail.messages.back_to_projects')}
                            hideCloseBtn
                        />
                    </div>
                )}
                {!this.state.loading && !!this.state.project && (
                    <AiTrackingPrompt
                        prompt_uids={this.state.prompt_uids}
                        from_project
                        project={this.state.project}
                        platforms={this.state.platforms}
                        getProjectData={this.getProjectData}
                        loadingProjectForChildren={this.state.loadingProjectForChildren}
                    />
                )}
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(AiTrackingProject);
